import React from 'react';

import RedInfoIcon from 'icons/info-red.svg';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import { sendAnalytics } from 'components/helpers/analytics';
import * as IntercomHelperModule from 'components/helpers/intercom';

export default function UnarchiveBlockedModal({ closeModal, isOpen, usage }) {
  const currentActor = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'personnel.UnarchiveBlockedModal',
  });

  const { t: i18nTCommon } = useTranslation('common');

  const handleUpgradeClick = () => {
    IntercomHelperModule.launchIntercomWithMessage(
      "Hello, I'm interested in upgrading my Training Register plan.",
    );

    closeModal();

    sendAnalytics('Upgrade clicked from unarchive blocked modal', {
      account: currentActor.account,
      division: currentActor.division,
      user: currentActor.user,
    });
  };

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={closeModal}
            size='md'
          >
            {i18nTCommon('shared.cancel')}
          </TextButton>
          <FilledButton color='mint' onClick={handleUpgradeClick}>
            {i18nTCommon('shared.upgradePlan')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={closeModal}
    >
      <div className='tw-p-8'>
        <div className='tw-mb-4 tw-font-inter tw-text-xl tw-font-semibold tw-text-grey-900'>
          {i18nT('title')}
        </div>
        <div className='b-standard br-3 tw-mb-3 tw-flex tw-items-center tw-border-grey-100 tw-bg-white tw-px-5 tw-py-3 tw-text-m'>
          <RedInfoIcon
            className='[&_path]:tw-fill-red-600'
            height='24px'
            width='24px'
          />
          <span className='tw-ml-3'>
            {i18nTCommon('personnel.trackedUsage', {
              allowance:
                currentActor.subscription.attributes.trackedPersonnelAllowance,
              usage,
            })}
          </span>
        </div>
        <div>{i18nT('description')}</div>
      </div>
    </ModalBox>
  );
}
